import { Injectable } from '@angular/core';
import { routeScheduledTiming } from '@medlogic/shared/shared-interfaces';
import { FhirGenericService } from './fhir-generic.service';

@Injectable({ providedIn: 'root' })
export class FhirScheduledTimingService extends FhirGenericService {
  protected url = routeScheduledTiming;

}
